export const SWATCH = {
  White: "#FFFFFF", Ash: "#D9D9D6", "Sport Gray": "#A7A8AA", Sand: "#D8C6A8", "Light Pink": "#F6C1D3", Red: "#C8102E",
  Orange: "#F4651F", Gold: "#FFB81C", Heliconia: "#E5338E", "Safety Pink": "#F59BBB", Maroon: "#6A1B2A", "Irish Green": "#00A651",
  "Military Green": "#5B6236", "Forest Green": "#234133", "Dark Chocolate": "#3E2B23", Purple: "#5B2C8D", "Light Blue": "#A4C8E1",
  "Carolina Blue": "#7BAFD4", "Indigo Blue": "#4F6A8F", Royal: "#1D4F9C", Navy: "#1F2A44", "Dark Heather": "#4B4D52", Black: "#111111",
};

export const money = (v) => `$${Number(v || 0).toFixed(2).replace(/\.00$/, "")}`;
